import Authenticate from '~/client/components/Auth/Authenticate';
import StepByStepAuthProvider from '~/client/components/Auth/Authenticate/AuthSteps/context/StepByStepAuthProvider';
import useIsStepByStepEnabled from '~/client/components/Auth/Authenticate/AuthSteps/hooks/useIsStepByStepEnabled';
import Login from '~/client/components/Auth/Login';
import Register from '~/client/components/Auth/Register';
import Stack from '~/client/shared/Stack';
type Props = {
  isRegister?: boolean;
};

const AuthenticatePopover: FC<Props> = ({ isRegister }) => {
  const isStepByStepRegistrationEnabled = useIsStepByStepEnabled();

  if (isStepByStepRegistrationEnabled) {
    return (
      <StepByStepAuthProvider>
        <Stack space="xlarge">
          <Authenticate isPopover />
        </Stack>
      </StepByStepAuthProvider>
    );
  }
  if (isRegister) {
    return <Register isPopover />;
  }
  return <Login isPopover />;
};
export default AuthenticatePopover;
